import useSWR, {KeyedMutator} from 'swr'
import {fetcher} from "./fetcher";
import {NotionPageShortData, PageData} from "@app/core-app/app/usecase/notion/fetch-pages";


export type PagesData = {
  data: PageData[] | null | undefined
  isLoading: boolean
  isError: any
  isValidating: boolean
  mutate: KeyedMutator<PageData[]>
}


export function useOutboxPages(databaseId: string | null): PagesData {
  const {data, error, mutate, isValidating} = useSWR(
    databaseId ? ["/api/notion/outbox", databaseId] : null,
    (key, id) => fetcher(key, {method: "POST", body: JSON.stringify({id: id})}),
    {focusThrottleInterval: 15000}
  )

  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
    isValidating
  }
}
export type AvailablePagesData = {
  data: NotionPageShortData[] | null | undefined;
  isLoading: boolean;
  isError: any;
};

type UseAvailablePagesParams = {
  isAuthorized?: boolean;
};

export const useAvailablePages = ({ isAuthorized = true }: UseAvailablePagesParams = {}): AvailablePagesData => {
  const { data, error, mutate } = useSWR(
    isAuthorized ? "/api/notion/pages" : null,
    (key) => fetcher(key, { method: "GET" })
  );

  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
  };
};



export function useAllDatabasePages(databaseId: string | null): PagesData {
  const {data, error, mutate, isValidating} = useSWR(
    databaseId ? [`/api/notion/outbox-full?id=${databaseId}`, databaseId] : null,
    (key) => fetcher(key, {method: "GET"}),
    {focusThrottleInterval: 15000}
  )

  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
    isValidating
  }
}

